import '../../../node_modules/select2/dist/js/select2';
/**
 * Init Select plugin with different methods
 */
export let select = {
    /**
    * Init simple select plugin
    *
    * @param el - an element on which will bw initialized select plugin
    */
    initDefaultSelect(el) {
        $(el).select2();
    },

    /**
     * Init select plugin without search field
     *
     * @param el - an element on which will bw initialized select plugin
     */
    initSelectWithoutSearch(el) {
        $(el).select2({
            minimumResultsForSearch: Infinity
        });
    },

    /**
     * Init select all functionality both for default checkboxes and for checkboxes with iCheck plugin
     *
     * @param el - a checkbox which will select/deselect all options
     */
    initSelectedAll(el) {

        $('body').on('change', el, function () {
            select.checkOnChangedCheckbox(this)
        });

        //for checkbox with iCheck plugin
        $(el).on('ifChanged', function(){
            select.checkOnChangedCheckbox(this)
        });
    },

    /**
     * Checks whether the checkbox has already checked or not
     *
     * @param el - a checkbox which will select/deselect all options
     */
    checkOnChangedCheckbox(el){

        if($(el).is(':checked') ){
            select.selectAll(el);
        }else{
            select.deselectAll(el);
        }
    },

    /**
     * selects all certain select options
     *
     * @param el - a checkbox which will select/deselect all options
     */
    selectAll(el){
        let thisSelect = $($(el).attr('data-select'));

        thisSelect.find('option').prop("selected","selected");
        thisSelect.trigger("change");// Trigger change to select 2
    },

    /**
     * deselects all certain select options
     *
     * @param el - a checkbox which will select/deselect all options
     */
    deselectAll(el){
        let thisSelect = $($(el).attr('data-select'));

        thisSelect.find('option').removeAttr("selected");
        thisSelect.trigger("change");// Trigger change to select 2
    }
};



// WEBPACK FOOTER //
// ./js/script/components/select.js